module.exports = __webpack_public_path__ + "img/m2.d9c590e7.png";